<template>
  <div>
    <ChallengeEditor
      :challenge="challenge"
      title="チャレンジ編集"
      save-label="保存"
      @save="save($event)"
    />

    <v-snackbar
      color="success"
      v-model="saved"
      :timeout="4000"
    >
      保存しました
    </v-snackbar>

    <v-snackbar
      color="error"
      v-model="failed"
      :timeout="6000"
    >
      エラー：{{ failed_message }}
    </v-snackbar>
  </div>
</template>

<script>
import firebase from "@/firebase/firebase.js"
import {db} from "@/firebase/db.js"

import ChallengeEditor from '@/components/ChallengeEditor.vue'

export default {
  components: {
    ChallengeEditor,
  },
  data: () => ({
    challenge: null,
    public_file_keys: ["readme", "kernel_header", "kernel_source", "public_tb"],
    private_file_keys: ["private_tb"],
    cid: null,
    saved: false,
    failed: false,
    failed_message: "",
  }),
  methods: {
    async save(challenge) {
      try {
        //console.log("Save challenge", challenge)
        const uid = this.$store.state.user.uid
        const userRef = db.collection("users").doc(uid)
        const challengeRef = userRef.collection("challenges").doc(this.cid)

        const challengeDat = Object.assign({}, challenge)
        challengeDat.user = uid
        challengeDat.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
  
        const cnameRef = db.collection("challengenames").doc(challenge.name)
        const cnameQuerySnapshot = await db.collection('challengenames').where('challenge', '==', challengeRef.id).get()
  
        // Check challenge name exists
        console.log("changing name")
        await db.runTransaction(async tx => {
          const cnameDoc = await tx.get(cnameRef)
          if (cnameDoc.exists && cnameDoc.data().challenge != challengeRef.id) {
            throw new Error('このチャレンジ名は使用されています')
          }
          cnameQuerySnapshot.forEach(async docSnapshot => await tx.delete(docSnapshot.ref))
          await tx.set(cnameRef, { user: userRef.id, challenge: challengeRef.id})
        })
  
        // Save files
        console.log("saving files")
        const public_files = {}
        const private_files = {}
        for (const key of this.public_file_keys) {
          public_files[key] = this.challenge.files[key]
        }
        for (const key of this.private_file_keys) {
          private_files[key] = this.challenge.files[key]
        }
        db.doc(this.challenge.public_files).update(public_files)
        db.doc(this.challenge.private_files).update(private_files)

        // Delete temporary files object
        delete challengeDat.files
        delete challengeDat.expireAtText

        // Update
        console.log("updating challenge")
        console.log(challengeDat)
        await challengeRef.update(challengeDat)

        this.$router.replace('/challenge/' + challengeDat.name)
      } catch (e) {
        console.log(e)
        this.failed_message = e.message
        this.failed = true
      }
    },
  },
  async created() {
    const uid = this.$store.state.user.uid
    const userRef = db.collection("users").doc(uid)
    const cnameDoc = await db.collection("challengenames").doc(this.$route.params.challenge_name).get()
    if (!cnameDoc.exists) return
    this.cid = cnameDoc.data().challenge
    const challengeDoc = await userRef.collection("challenges").doc(this.cid).get()
    if (!challengeDoc.exists) return
    const challengeData = challengeDoc.data()
    challengeData.files = {}
    challengeData.expireAtText = challengeData.expireAt.toDate().toISOString().substr(0, 10)
    if (!("do_synth" in challengeData.regulation)) {
      challengeData.regulation.do_synth = true
    }
    this.challenge = challengeData

    // Copy file contents to temporary files object
    const files = {}
    const public_files = await db.doc(this.challenge.public_files).get()
    const private_files = await db.doc(this.challenge.private_files).get()
    for (const key of this.public_file_keys) {
      files[key] = public_files.data()[key]
    }
    for (const key of this.private_file_keys) {
      files[key] = private_files.data()[key]
    }
    this.challenge.files = files
  }
}
</script>


